/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import './Introduction.scss';
import { getRuntimeEnvVariables } from 'helpers/Utils';
import {
  Heading,
  Paragraph,
  Icon,
} from 'components/common/';

const market = process.env.RAZZLE_MARKET;
const isBrandRefreshing = getRuntimeEnvVariables('RUNTIME_BRAND_REFRESHING') === 'true'
                        && market === 'moneyhero';

const Introduction = ({
  title, text, list, brandRefreshTitle, brandRefreshText,
}) => (
  <div className="introduction">
    <div className="introduction__content">
      <Heading as="h3">{isBrandRefreshing ? brandRefreshTitle : title}</Heading>
      <div className="introduction__paragraph">
        <Paragraph>{isBrandRefreshing ? brandRefreshText : text}</Paragraph>
      </div>
      {list && list.map(item => (
        <div className="introduction__icon" key={item.icon}>
          <Paragraph>
            {isBrandRefreshing
              ? <img src="/check.png" alt="check icon" style={{ width: '16px', height: '16px' }} />
              : <Icon name={item.icon} secondary />}
            <span className="introduction__icon__lable">{isBrandRefreshing ? item.brandRefreshLabel : item.label}</span>
          </Paragraph>
        </div>
      ))}
    </div>
  </div>
);

Introduction.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};

export default Introduction;
